import { types, actions } from './requests'
export const DELETETASK_TYPES = {
    ...types('DELETETASK'),
}
export const DELETETASK_ACTIONS = {
    ...actions('DELETETASK'),
}